// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OrderDetailsGrid_gridContainer__25nWD","gridOverlay":"OrderDetailsGrid_gridOverlay__1eFl8"};